import React from 'react';
export function Loading() {
  return <div className="flex min-h-[70vh] flex-col items-center justify-center gap-4 px-6 text-center" role="status" aria-live="polite" data-id="element-90" data-mp="37cigv36pauhm">
      <div className="h-8 w-8 animate-spin rounded-full border-[3px] border-border border-t-teal" data-id="element-91" data-mp="2au7cy7t2x2j3" />
      <p className="text-sm text-ink-light" data-id="element-92" data-mp="25u1h0ffs0tv7">Building your profile…</p>
    </div>;
}